module.exports = __webpack_public_path__ + "img/sales_icon.fdddedb0.svg";